import { render, staticRenderFns } from "./mdUploader.vue?vue&type=template&id=5947c984&scoped=true&"
import script from "./mdUploader.vue?vue&type=script&lang=js&"
export * from "./mdUploader.vue?vue&type=script&lang=js&"
import style0 from "./mdUploader.vue?vue&type=style&index=0&id=5947c984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947c984",
  null
  
)

export default component.exports